import React from 'react';
import { Text } from "../custom-components";

const UserPortalConfiguration = () => {
  return (
    <div className="configurePage">
      <div className="template-header-section" style={{ marginTop: '24px' }}>
        <Text appearance="heading-s" color="primary-grey-100">
          User Portal Configuration
        </Text>
      </div>
      <div style={{ padding: '24px', backgroundColor: 'white', borderRadius: '8px', marginTop: '24px' }}>
        <Text>Upcoming</Text>
      </div>
    </div>
  );
};

export default UserPortalConfiguration;
